import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { NewsWidgetItem } from './News.interface';
import { NewsSingle } from './NewsSingle';
import './NewsWidget.scss';
import { WidgetsHeadline } from '../WidgetsHeadline/WidgetsHeadline';
import { CalendarLtrRegular } from '@fluentui/react-icons';
import { Text } from '../../Text/Text';
import { NewsSingleSkeleton } from './NewsSingleSkeleton';

export interface NewsWidgetProps {
  isLoading: boolean;
  news: NewsWidgetItem[];
  error?: Error | null;
  classNames?: string;
}

export const NewsWidget: FC<NewsWidgetProps> = ({
  isLoading,
  news,
  error,
  classNames,
}) => {
  const { t } = useTranslation();

  // Hide widget completely when there are no news and not loading
  if (!isLoading && !error && (!news || news.length === 0)) {
    return null;
  }

  return (
    <div className={cn('newsWidget', classNames)}>
      <WidgetsHeadline
        content={t('dashboard:news:news', { defaultValue: 'Neuigkeiten' })}
        icon={<CalendarLtrRegular fontSize={24} />}
      />
      {!isLoading && error && (
        <Text color="danger">
          {t('dashboard:news:errorMessageText', { defaultValue: 'Fehler beim Laden der Neuigkeiten' })}
        </Text>
      )}
      {!isLoading &&
        !error &&
        news?.map((newsItem, index) => (
          <NewsSingle news={newsItem} key={index} classNames="single" />
        ))}
      {isLoading && <NewsSingleSkeleton />}
    </div>
  );
};
